// CONTENT LIBRARY SLIDER
document.addEventListener('DOMContentLoaded', function() {
  const contentLibrarySliders = document.querySelectorAll('.c-slider-wrap.content-library .c-slider');
  if(contentLibrarySliders.length > 0){
    contentLibrarySliders.forEach(contentLibrarySlider => {
      var contentLibrarySwiper = new Swiper(contentLibrarySlider, {
        loop: true,
        slidesPerView: 1,
        speed: 500,
        spaceBetween: 24,
        navigation: {
          nextEl: contentLibrarySlider.parentElement.querySelector('.c-slider-arrow.next'),
          prevEl: contentLibrarySlider.parentElement.querySelector('.c-slider-arrow.prev'),
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 28,
            // centeredSlides: true,
          },
        },
      });
    });
  }
});